export default function AboutSection() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header with Logo */}
        <div className="text-center mb-20">
          <div className="inline-flex items-center justify-center mb-6">
            <img
              src="https://static.readdy.ai/image/9e0ec1f08df5eac0f8e6ee60a23adb36/71c80160d04a459cf0ff28e8673272c6.png"
              alt="Tello Crafts Logo"
              className="h-24 w-auto"
            />
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            The Story Behind the Hands
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Our logo represents more than just a brand - it's the heart of who we are
          </p>
        </div>

        {/* Logo Meaning Section */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-20">
          <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-3xl p-8 text-center border border-amber-100">
            <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
              <i className="ri-hand-heart-line text-4xl text-amber-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Two Hands</h3>
            <p className="text-gray-600 leading-relaxed">
              Representing a husband and wife team working together, each bringing unique skills and passion to every creation
            </p>
          </div>

          <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-3xl p-8 text-center border border-amber-100">
            <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
              <i className="ri-home-heart-line text-4xl text-amber-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">One Home</h3>
            <p className="text-gray-600 leading-relaxed">
              The house formed by our hands symbolizes that everything is crafted in our home workshop with love and dedication
            </p>
          </div>

          <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-3xl p-8 text-center border border-amber-100">
            <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
              <i className="ri-heart-3-line text-4xl text-amber-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Made with Heart</h3>
            <p className="text-gray-600 leading-relaxed">
              Every piece carries the warmth of our home and the care of our hands, creating treasures for your family
            </p>
          </div>
        </div>

        {/* Our Story */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=warm-inviting-home-woodworking-workshop-interior-with-wooden-workbench-tools-hanging-on-walls-natural-sunlight-streaming-through-windows-cozy-artisan-craftsman-space-filled-with-handmade-wooden-pieces-rustic-homey-atmosphere-soft-warm-lighting-shallow-depth-of-field-professional-photography&width=800&height=1000&seq=about-workshop-home-002&orientation=portrait"
                alt="Our home workshop"
                className="w-full h-full object-cover"
              />
              <div className="absolute top-6 left-6 bg-white/95 backdrop-blur-sm rounded-2xl px-6 py-3 shadow-lg">
                <div className="flex items-center gap-3">
                  <i className="ri-home-smile-line text-2xl text-amber-600"></i>
                  <span className="text-sm font-semibold text-gray-900">Our Home Workshop</span>
                </div>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-3xl font-bold text-gray-900 mb-6">
              A Family Tradition Born from Passion
            </h3>
            <div className="space-y-4 text-gray-600 leading-relaxed">
              <p>
                What started as a hobby in our garage has blossomed into a full-fledged passion. As a husband and wife team, we discovered that our combined skills created something truly special.
              </p>
              <p>
                He brings precision and technical expertise to wood turning, while she adds artistic flair through painting and design. Together, our four hands work in harmony to create pieces that are both functional and beautiful.
              </p>
              <p>
                Every item that leaves our home workshop carries a piece of our story - the late nights perfecting a design, the joy of discovering a new technique, and the satisfaction of creating something that will be treasured in another family's home.
              </p>
            </div>

            <div className="mt-8 grid grid-cols-2 gap-6">
              <div className="bg-amber-50 rounded-2xl p-6 border border-amber-100">
                <div className="flex items-center gap-3 mb-2">
                  <i className="ri-user-heart-line text-2xl text-amber-600"></i>
                  <span className="text-2xl font-bold text-gray-900">2</span>
                </div>
                <p className="text-sm text-gray-600">Passionate Artisans</p>
              </div>
              <div className="bg-amber-50 rounded-2xl p-6 border border-amber-100">
                <div className="flex items-center gap-3 mb-2">
                  <i className="ri-home-4-line text-2xl text-amber-600"></i>
                  <span className="text-2xl font-bold text-gray-900">1</span>
                </div>
                <p className="text-sm text-gray-600">Home Workshop</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
